<template>
  <i
    class="iconfont icon-container"
    :class="fontClass"
    :style="{ fontSize: size + 'px', color: color }"
  ></i>
</template>
<script>
const classMap = {
  home: "icon-dzclubzhuye", //1
  userinfo: "icon-dzclubuserinfo",
  location: "icon-dzclubdidian", //1
  equity: "icon-dzclubquanyi", //1
  dateTime: "icon-dzclubdatatime", //1
  jiFen: "icon-dzclubjifen", //1
  myActive: "icon-dzclubbaoming", //1
  back: "icon-dzclubback", //1
  empty: "icon-dzclubempty", //1
  shop: "icon-dzclubdianpu", //1
  kefu: "icon-dzclubkefu", //1
  close: "icon-dzclubguanbi", //1
  fuzhi: "icon-dzclubfuzhi-", //1
  shezhi: "icon-dzclubshezhi", //1
  fuwuhao: "icon-dzclubfuwuhao",
  xinmin: "icon-dzclubx", //1
};

export const types = Object.keys(classMap);
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    size: {},
    color: {},
  },
  computed: {
    fontClass() {
      return classMap[this.type];
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/styles/iconfont.css";
.iconfont {
  color: inherit;
  font-size: inherit;
}
</style>